import { useEffect, useState } from "react";
import GroupButtons from "../../../../../Components/GroupButtons/GroupButtons";
import ScrollableList from "../../../../../Components/ScrollableList/ScrollableList";
import ServerRequests from "../../../../../Services/Api/ServersRequests.ts";
import { useParams } from "react-router-dom";
import { FaEdit, FaPen, FaTrash } from "react-icons/fa";
import { GetDateFromTicks } from "../../../../../Services/DateManager/DateManager.js";
import { MdEdit } from "react-icons/md";
import AddEditBanModal from "./Components/AddEditBanModal.js";
import HideShowField from "../../../../../Components/HideShowField/HideShowField.js";

const Punishments = () => {
    const serverRequests = new ServerRequests();

    const { serverId } = useParams();

    const [selected, setSelected] = useState(0);
    const [punishments, setPunishments] = useState(null);

    const [selectedBan, setSelectedBan] = useState(null);

    useEffect(() => {
        refresh();
    }, [serverId])

    const refresh = () => {
        serverRequests.GetPunishmentsData(serverId, (data) => 
        {
            if(data.length < 2){
                setPunishments([[], [], []])
                return;
            }
                
            let processedData = [];
            processedData.push(data[0].map(x => processBans(x, (f) => <p><span className="text-glwhite-600">Id:</span> {f}</p>)));
            processedData.push(data[1].map(x => processBans(x, (f) => <p className="flex gap-1"><span className="text-glwhite-600">IP:</span> <HideShowField field={f}/></p>)));
            processedData.push(data[2].map(x => processMutes(x)));

            setPunishments(processedData);
        })
    }


    const processBans = (data, secondField) => {
        let fields = data.split(';');

        return {
            columns: [
                <div className="flex">
                    <div className="w-[35%]">
                        <p><span className="text-glwhite-600">Username:</span> {fields[0]}</p>
                        <p>{secondField(fields[1])}</p>

                    </div>
                    <div className="w-[35%]">
                        <p><span className="text-glwhite-600">Reason:</span> {fields[3]}</p>
                        <p><span className="text-glwhite-600">Banned by:</span> {fields[4]}</p>
                    </div>
                    <div className="w-[30%]">
                        <p><span className="text-glwhite-600">Banned (Date):</span> {GetDateFromTicks(fields[5]).toLocaleDateString()}</p>
                        <p><span className="text-glwhite-600">Banned Until:</span> {GetDateFromTicks(fields[2]).toLocaleDateString()}</p>
                    </div>
                </div>
            ],
            text: fields,
            id: data,
        }
    }

    const processMutes = (data) => {
        return { text: data, columns: data, id: data, }
    }
    
    const editBan = (data, isIp) => {
        setSelectedBan({isIp: isIp, data: data});
    }

    //TODO: Add loading info
    const remove = (toRemove, type) => {
        const data = { 
            ServerId: serverId,
            Type: type,
            Data: toRemove
        };

        serverRequests.RemovePunishment(data, () => {
            setTimeout(() => {
                refresh();
            }, 4000)
        })
    }

    const hideAddEdit = () => {
        setSelectedBan(null);
        
        setTimeout(() => {
            refresh();
        }, 2000)
    }

    return (
        <div className="card panelFull">
            <GroupButtons 
                buttons={[
                    { text: "Mutes" },
                    { text: "Bans" },
                    { text: "IP Bans" },
                ]}
                selected={selected}
                setSelected={setSelected}
            />

            { selectedBan &&
                <AddEditBanModal serverId={serverId} selectedBan={selectedBan.data} isIp={selectedBan.isIp} hide={hideAddEdit}/>
            } 

            <div className="mt-4">
                { selected == 0 &&
                    <ScrollableList 
                        title={"Mutes"}
                        listClass={"overflow-y-auto overflow-x-hidden h-[70vh]"}  
                        data={punishments ? punishments[2] : null}     
                        removeFunction={(data) => remove(data, 2)}
                        removeTitle={"Usunięcie Mute"}
                    /> 
                }

                { selected == 1 &&
                    <ScrollableList 
                        title={"Bans"}
                        data={punishments ? punishments[0] : null}
                        listClass={"overflow-y-auto overflow-x-hidden h-[70vh]"}  
                        removeFunction={(data) => remove(data, 0)} 
                        removeTitle={"Usunięcie Bana"}
                        customButtons={[
                            { icon: <MdEdit size={"22px"} className="iconBtn"/>, onClick: (data) => {editBan(data, false)} }
                        ]}
                    /> 
                }  

                { selected == 2 &&
                    <ScrollableList 
                        title={"IP Bans"}
                        data={punishments ? punishments[1] : null}   
                        listClass={"overflow-y-auto overflow-x-hidden h-[70vh]"}    
                        removeFunction={(data) => remove(data, 1)}       
                        removeTitle={"Usunięcie Bana IP"}
                        customButtons={[
                            { icon: <MdEdit size={"22px"} className="iconBtn"/>, onClick: (data) => {editBan(data, true)} }
                        ]}
                    /> 
                }                              
            </div>
        </div>
    )
}

export default Punishments;